"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ClickOutside_1 = require("./ClickOutside");
exports.ClickOutside = ClickOutside_1.ClickOutside;
//# sourceMappingURL=index.js.map